import { BitpandaLogoDark } from './BitpandaLogoDark';
import { GlobalCoinLogo } from './GlobalCoinLogo';
import { GlobalEtfLogo } from './GlobalEtfLogo';
import { GlobalEtcLogo } from './GlobalEtcLogo';
import { GlobalMetalLogo } from './GlobalMetalLogo';
import { GlobalStockLogo } from './GlobalStockLogo';
import { IslamicStar } from './IslamicStar';
import defaultAssetImg from './default-image/default-asset.svg';
import { defaultAssetInlineEncoded } from './default-image/default-asset-inline.svg';
import defaultAssetPngImg from './default-image/default_asset_image.png';

export {
  GlobalCoinLogo,
  GlobalEtfLogo,
  GlobalEtcLogo,
  GlobalMetalLogo,
  GlobalStockLogo,
  defaultAssetInlineEncoded,
  defaultAssetImg,
  defaultAssetPngImg,
  BitpandaLogoDark,
  IslamicStar,
};
